export const DescriptionsTexts = {
  Raluca: 
  {
    Paragraf1: 
    `Numele meu este Raluca Albu și sunt psiholog cu certificare în psihoterapie și psihologie organizațională. \
    Am o experiență de peste 25 de ani în consiliere, dezvoltare personală,  psihoterapie, precum și în crearea și dezvoltarea \
    programelor de training, workshopuri și intervenții personalizate pentru echipe și organizații. \
    De-a lungul timpului, am avut privilegiul de a însoți oameni în momente importante din viața lor — uneori dificile, \
    alteori pline de descoperiri — și de a le fi alături în procesul lor de transformare.`,
    Paragraf2: 
    `Formarea mea de bază este în terapie cognitiv-comportamentală, pe care am completat-o și cu alte abordări terapeutice, \
    pe care le-am integrat în practica mea. Cred că fiecare persoană este unică, cu propriul ritm și propria poveste — de aceea, \
    îmi adaptez modul de lucru astfel încât să răspund cât mai autentic și eficient fiecărei nevoi.`,
    Paragraf3:
    `Cred în puterea vulnerabilității asumate, în claritatea comunicării și în colaborarea reală din cadrul procesului terapeutic. \
    Respectul, responsabilitatea, empatia și integritatea sunt valorile pe care le aduc în relațiile mele.`,
    Paragraf4:
    `Îmi doresc să ofer un spațiu sigur, cald și lipsit de judecată — un loc în care să te poți exprima liber, să te înțelegi mai bine \
    și să găsești resursele de care ai nevoie pentru a merge mai departe.`
  },
  Ana: {
    Paragraf1: 
    `Sunt Ana-Maria Bădescu, psiholog cu drept de liberă practică în specialitățile psihologie organizațională și \
    psihoterapie cognitiv-comportamentală. Am o experiență de peste 25 ani în selecția și evaluarea de personal, \
    training, dezvoltarea și coordonarea de programe pentru dezvoltarea echipelor, leadership organizațional, \
    dezvoltarea personală a angajaților, consiliere psihologică și psihoterapie.`,
    Paragraf2:
    `Am devenit psiholog pentru că m-a atras dintotdeauna complexitatea minții umane, mi-am dorit să mă cunosc \
    și să devin o versiune mai bună a mea. Pe măsură ce am câștigat experiență profesională, am învățat, mai \
    mult decât încrederea în cunoștințele dobândite, că avem capacitatea de a ne depăși limitele și de a evolua, \
    chiar și în momente de blocaj sau suferință.`,
    Paragraf3:
    `Pentru mine, însoțirea unui alt om pe drumul dezvoltării personale și al vindecării emoționale este un \
    privilegiu și o responsabilitate. Îmi doresc să construiesc relații bazate pe respect, acceptare, empatie și autenticitate.`
  }
};
